import {noop} from 'lodash';
import {Dispatch, SetStateAction} from 'react';

import {
  createMandatoryContext,
  Handler,
  HandlerOf,
} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {CustomFields} from '../commons/customFieldsModel';
import {buildImmediateExpressions} from './expressionInferHelpers';
import {Expression} from './expressionModel';
import {InferredType} from './infer/expressionResultModel';

/*
 * Types.
 */

export interface ExpressionCreationState {
  allowedTypes?: ReadonlyArray<InferredType>;
  onCreateExpression: HandlerOf<Expression>;
}

export interface ExpressionsContext {
  expressions: ReadonlyArray<Expression>;
  hasAnyExpressions: boolean;
  customFields: CustomFields;
  initialInfer: InferredType;

  setPanelOpen: Handler;
  expressionCreationState?: ExpressionCreationState;
  setExpressionCreationState: Dispatch<SetStateAction<ExpressionCreationState | undefined>>;
}

export interface CreateExpressionContextProps {
  expressions: ReadonlyArray<Expression>;
  customFields: CustomFields;
  initialInfer: InferredType;

  setPanelOpen?: Handler;
  expressionCreationState?: ExpressionCreationState;
  setExpressionCreationState?: Dispatch<SetStateAction<ExpressionCreationState | undefined>>;
}

/*
 * Context.
 */

export const [ExpressionsContext, useExpressionsContext] = createMandatoryContext<ExpressionsContext>();

export const createExpressionsContext = ({
  expressions,
  customFields,
  initialInfer,

  // TODO: someday, have the onSetPanelOpen action accessible from anywhere
  setPanelOpen = noop,
  expressionCreationState,
  setExpressionCreationState = noop,
}: CreateExpressionContextProps): ExpressionsContext => {
  const immediateExpressions = buildImmediateExpressions(initialInfer);

  return {
    customFields,
    expressions: [...immediateExpressions, ...expressions],
    initialInfer,
    hasAnyExpressions: expressions.length > 0,
    setPanelOpen,
    expressionCreationState,
    setExpressionCreationState,
  };
};
